'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _d2 = require('d3');

var d3 = _interopRequireWildcard(_d2);

var _d3SvgLegend = require('d3-svg-legend');

var _d3SvgLegend2 = _interopRequireDefault(_d3SvgLegend);

require('./lineChart.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var prepareOptions = function prepareOptions(data) {
  // check for required options
  if (!data.measureId) {
    throw new Error('data.measureId not defined');
  }
  if (!data.geographicItemsFilter) {
    throw new Error('data.geographicItemsFilter not defined');
  }

  // default temporal: all data from 2000
  var temporal = data.temporal || '2000-' + new Date().getFullYear();
  // temporal can be either: string (one year YYYY), string (year range YYYY-YYYY), array of strings (years)
  if (typeof temporal === 'string' && temporal.length === 9) {
    // YYYY-YYYY
    var _temporal$split = temporal.split('-'),
        _temporal$split2 = _slicedToArray(_temporal$split, 2),
        start = _temporal$split2[0],
        stop = _temporal$split2[1];

    if (start > stop) {
      throw new Error('data.temporal not valid');
    }
    temporal = [];
    /*eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }]*/
    for (var i = start; i <= stop; i++) {
      temporal.push(i.toString());
    }
  } else if (!Array.isArray(temporal) && typeof temporal === 'string' && temporal.length !== 4) {
    throw new Error('data.temporal not valid');
  }

  var options = {
    measureId: data.measureId, // required, no default
    stratificationLevelId: data.stratificationLevelId || '1', // default state
    geographicTypeIdFilter: data.geographicTypeIdFilter || '1', // default state
    geographicItemsFilter: data.geographicItemsFilter, // required, no default; fips codes
    temporal: temporal,
    isSmoothed: data.isSmoothed || '0', // default not smoothed
    queryParams: data.queryParams ? '?' + data.queryParams : '' // not required, no default
  };

  return options;
};

var lineChart = function lineChart(container, data, title) {
  var options = prepareOptions(data);
  var url = 'https://ephtracking.cdc.gov/DataExplorer/getCoreHolder/' + options.measureId + '/' + options.stratificationLevelId + '/' + options.geographicTypeIdFilter + '/' + options.geographicItemsFilter + '/' + options.temporal + '/' + options.isSmoothed + '/0' + options.queryParams;
  d3.json(url, function (error, response) {
    if (error) {
      console.error(error);
    } else if (response[response.tableReturnType] && response[response.tableReturnType].length > 0) {

      /* eslint-disable no-inner-declarations */
      var createLegend = function createLegend(l) {
        var ordinal = d3.scaleOrdinal().domain(l).range(colors);

        svg.append('g').attr('class', 'legend').attr('transform', 'translate(' + (width + margin.left + marginLegend) + ', ' + margin.top + ')');

        var legendOrdinal = _d3SvgLegend2.default.legendColor().scale(ordinal).classPrefix('ephviz-').labelWrap(150);

        var svgLegend = svg.select('.legend').call(legendOrdinal);
        svgLegend.exit().remove();
      };

      /* eslint-disable no-inner-declarations */
      var mousemove = function mousemove() {
        var x0 = x.invert(d3.mouse(this)[0]);
        var bisectDate = d3.bisector(function (d) {
          return new Date(d.year, 0, 1);
        }).left;
        var i = bisectDate(sortedData, x0, 1);
        var d = void 0;
        // last element
        if (i === sortedData.length) {
          d = new Date(sortedData[i - 1].year, 0, 1);
        } else {
          var d0 = new Date(sortedData[i - 1].year, 0, 1);
          var d1 = new Date(sortedData[i].year, 0, 1);
          d = x0 - d0 > d1 - x0 ? d1 : d0;
        }
        // move line
        hoverLine.attr('x1', x(d));
        hoverLine.attr('x2', x(d));
        // update legend
        var newLabels = keys.map(function (key, index) {
          if (index < 10) {
            var selectedYear = d.getFullYear().toString();
            var entry = lines[key].find(function (element) {
              return element.year === selectedYear;
            });
            if (!entry) {
              return key + ': no data (' + selectedYear + ')';
            }
            var stratification = lookupList[entry.lookupListId] ? lookupList[entry.lookupListId].map(function (i) {
              return i.itemName;
            }).join(', ') : null;
            var labelKey = stratification ? entry.geo + ', ' + stratification : entry.geo;
            return labelKey + ' - ' + entry.rollover;
          }
        });
        createLegend(newLabels);
      };

      // overlay for mouseover events


      var preparedData = response[response.tableReturnType].map(function (item) {
        return {
          // ToDo: Refactor and create Data object here
          year: item.year.trim().substr(0, 4), // only get first year
          label: item.year, // for measures over e.g. 5 years (2000 - 2005)
          dataValue: item.dataValue ? parseFloat(item.dataValue) : null,
          displayValue: item.displayValue,
          geo: item.geo,
          geoId: item.geoId,
          geoAbbreviation: item.geoAbbreviation,
          lookupListId: item.groupById,
          rollover: item.rollover
        };
      });
      var lookupList = response.lookupList;

      var sortedData = preparedData.sort(function (a, b) {
        return a.year - b.year;
      });
      // data is in form: year, dataValue, displayValue (all string), sorted by year

      // --- create d3 line chart ---
      // color scheme
      var colors = ['#c06568', '#64ac48', '#8361cc', '#9a963f', '#c167b1', '#4aac8d', '#d14076', '#688bcd', '#ce4f34', '#c98743'];

      // container
      var svg = d3.select(container);
      var top = title ? 50 : 20;
      var margin = { top: top, right: 180, bottom: 30, left: 80 };
      var marginLegend = 20;
      var marginTitle = 30;
      var marginSource = 10;
      var width = +svg.attr('width') - margin.left - margin.right - marginLegend;
      var height = +svg.attr('height') - margin.top - margin.bottom - marginSource;

      // create title
      if (title) {
        svg.append('text').attr('x', svg.attr('width') / 2).attr('y', margin.top / 2).attr('text-anchor', 'middle').attr('font-family', 'Verdana, Geneva, sans-serif').attr('font-size', '14px').text(title);
      }

      // create source at bottom
      svg.append('a')
      // .attr('transform', `translate(10, ${svg.attr('height') - 10})`)
      .attr('xlink:href', 'https://ephtracking.cdc.gov').attr('target', '_blank').append('text').attr('x', 10).attr('y', svg.attr('height') - 10).attr('font-family', 'Verdana, Geneva, sans-serif').attr('font-size', '11px').attr('fill', '#808080').text('Source: National Environmental Public Health Tracking Network, CDC');

      // create line chart
      var g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
      var x = d3.scaleTime().range([0, width]);
      var y = d3.scaleLinear().rangeRound([height, 0]);

      // prepare years for x axis (sort and unique values)
      var years = sortedData.map(function (d) {
        return d.year;
      });
      var startYear = d3.min(years, function (d) {
        return parseInt(d, 10);
      });
      var endYear = d3.max(years, function (d) {
        return parseInt(d, 10);
      });
      var allYears = Array.from({ length: endYear - startYear + 1 }, function (v, k) {
        return new Date(k + startYear, 0, 1);
      });

      x.domain([allYears[0], allYears[allYears.length - 1]]).tickFormat(d3.timeFormat('%Y'));
      y.domain(d3.extent(sortedData, function (d) {
        return d.dataValue;
      }));

      var xAxis = d3.axisBottom(x).ticks(d3.timeYear.every(1));

      g.append('g').attr('transform', 'translate(0, ' + height + ')').attr('class', 'ephviz-axis').call(xAxis);

      g.append('g').attr('class', 'ephviz-axis').call(d3.axisLeft(y).ticks(5)).select('.domain') // remove line from y-axis
      .remove();

      // grid lines
      var gridLines = d3.axisLeft(y).tickFormat('').ticks(5).tickSize(-width);
      g.append('g').attr('class', 'ephviz-grid-lines').call(gridLines);

      // group data by state and stratification
      var lines = {};
      sortedData.forEach(function (item) {
        var lineKey = item.geoId + '-' + item.lookupListId;
        if (lines[lineKey]) {
          lines[lineKey].push(item);
        } else {
          lines[lineKey] = [item];
        }
      });

      // draw lines
      var line = d3.line().defined(function (d) {
        return d.dataValue !== null;
      }).x(function (d) {
        return x(new Date(d.year, 0, 1));
      }).y(function (d) {
        return y(d.dataValue);
      });

      var keys = Object.keys(lines);
      var labels = [];
      keys.forEach(function (key, index) {
        // up to 10
        if (index < 10) {
          g.append('path').datum(lines[key]).attr('fill', 'none').attr('stroke', colors[index]).attr('stroke-linejoin', 'round').attr('stroke-linecap', 'round').attr('stroke-width', 2).attr('d', line);

          var numberElements = lines[key].length;
          var lastElement = lines[key][numberElements - 1];
          var stratification = lookupList[lastElement.lookupListId] ? lookupList[lastElement.lookupListId].map(function (i) {
            return i.itemName;
          }).join(', ') : '';
          var labelKey = stratification ? lastElement.geo + ', ' + stratification : lastElement.geo;
          labels.push(labelKey + ' - ' + lastElement.rollover);

          // draw data dots
          g.selectAll('.circle-' + index).data(lines[key]).enter().append('circle').attr('class', '.circle-' + index + ' .circle').attr('cx', function (d) {
            return x(new Date(d.year, 0, 1));
          }).attr('cy', function (d) {
            return y(d.dataValue);
          }).attr('r', 5).attr('stroke', '#fff').attr('stroke-width', 2).attr('fill', colors[index]);
        }
      });

      createLegend(labels);

      // overlay and update legend on mouse move
      // line to show on hover
      var hoverLine = g.append('line').attr('class', 'ephviz-hover-line').style('display', 'none').attr('x1', 0).attr('y1', 0).attr('x2', 0).attr('y2', height);svg.append('rect').attr('class', 'ephviz-overlay').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')').attr('width', width).attr('height', height).on('mouseover', function () {
        return hoverLine.style('display', null);
      }).on('mouseout', function () {
        hoverLine.style('display', 'none');
        createLegend(labels);
      }).on('mousemove', mousemove);
    } else {
      d3.select(container).append('text').attr('y', '20').attr('font-family', 'monospace').text('no data');
    }
  });
};

exports.default = lineChart;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ephtracking-viz/dist/visualizations/lineChart.js
// module id = 793
// module chunks = 0